module.exports = __webpack_public_path__ + "img/logo-white.65b01c08.png";